import { useState, useEffect } from 'react';
import { getPlatformSettings, getDefaultSettings } from '../utils/platformSettingsService';

/**
 * React hook for accessing platform settings
 * Automatically fetches and caches settings
 * @returns {object} { settings, loading, error, refresh }
 */
export function usePlatformSettings() {
  const [settings, setSettings] = useState(getDefaultSettings());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSettings = async () => {
    try {
      setLoading(true);
      setError(null);
      const fetchedSettings = await getPlatformSettings();
      setSettings(fetchedSettings);
    } catch (err) {
      console.error('Error loading platform settings:', err);
      setError(err);
      // Keep default settings on error
      setSettings(getDefaultSettings());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  return {
    settings,
    loading,
    error,
    refresh: loadSettings,
  };
}

